export default "__VITE_ASSET__2646eeb1__"